const SIM_OFFERS_PROVIDERS = {
    WIRELESS_LOGIC: {
        name: 'Wireless Logic',
        key: 'WIRELESS_LOGIC',
        entities: {
            name: 'details.sim_offers.service.name',
            manage: 'details.sim_offers.service.manage'
        }
    },
    BOUYGUES_TELECOM: {
        name: 'Bouygues Telecom',
        key: 'BOUYGUES_TELECOM',
        entities: {
            name: 'details.sim_offers.bouygues_telecom.name',
            manage: 'details.sim_offers.bouygues_telecom.manage'
        }
    }
};

export default SIM_OFFERS_PROVIDERS;